import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';

import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import Utilisateur from 'components/Shared/Utilisateur';

import { green } from '@mui/material/colors';

const styles = theme => ({

    chip: {
        margin: theme.spacing(0, 1, 1, 0)
    },

    root: {
        margin: 0,
        padding: 0
    },

    bold: {
        fontWeight: theme.typography.fontWeightMedium
    },


    table: {
        minWidth: 700
    },

    buttonProgress: {
        color: green[500],
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12
    },

    link: theme.style.link,
    
       
    warnFlag: {
        color: theme.palette.secondary.main,
        fontWeight: 'bold',
        letterSpacing: '2px'
    },


    nowrapCell: {
        whiteSpace: 'nowrap'
    }    
});



class AdministrationGroupes extends React.Component {
    

    render() {
        let { classes, groupes } = this.props;

        return (
            <React.Fragment>

                <Typography gutterBottom variant="h5">
                    Administration des groupes de traitement
                </Typography>


                <Paper className={classes.root}>

                    <Table className={classes.table} size='small'>
                        <TableHead>
                            <TableRow>
                                <TableCell align='right'>Id</TableCell>
                                <TableCell>Code</TableCell>
                                <TableCell>Libellé</TableCell>
                                <TableCell>Initiales</TableCell>
                                <TableCell>Actif</TableCell>
                                <TableCell>Visible</TableCell>
                                <TableCell>Création dossier après-vente lié</TableCell>
                                <TableCell>SAV Autorisé</TableCell>
                                <TableCell>Mémo Autorisé</TableCell>
                                <TableCell>Notifier emetteur dossier</TableCell>
                                <TableCell>Notifier pilote</TableCell>
                                <TableCell>Pilote</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {groupes.map(groupe => {
                                return (
                                    <TableRow key={groupe.id}
                                        hover
                                    >
                                        <TableCell component="th" scope="row" align='right'>
                                            <Link to={`/administration/groupes/${groupe.id}`} className={classes.link}>
                                                <Typography variant="button">
                                                    {groupe.id}
                                                </Typography>
                                            </Link>
                                        </TableCell>
                                        <TableCell>{groupe.code}</TableCell>
                                        <TableCell className={classes.nowrapCell}>{groupe.libelle}</TableCell>
                                        <TableCell>{groupe.initiales}</TableCell>
                                        <TableCell>{groupe.actif ? 'Oui' : 'Non'}</TableCell>
                                        <TableCell>{groupe.visible ? 'Oui' : 'Non'}</TableCell>
                                        <TableCell>{groupe.autoriseCreationReclamationLiee ? 'Oui' : 'Non'}</TableCell>
                                        <TableCell>{groupe.autoriseSAV ? 'Oui' : 'Non'}</TableCell>
                                        <TableCell>{groupe.autoriseMemo ? 'Oui' : 'Non'}</TableCell>
                                        <TableCell>{groupe.notifierEmetteurReclamation ? 'Oui' : <span className={classes.warnFlag}>Non</span>}</TableCell>
                                        <TableCell>{groupe.notifierPilote ? 'Oui' : 'Non'}</TableCell>
                                        <TableCell>
                                            {groupe.pilotes.map(pilote => {
                                                return (
                                                    <Utilisateur className={classes.chip} key={pilote.id} utilisateur={pilote} format="chip" />
                                                );
                                            })}
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>

                </Paper>

            </React.Fragment>


        );
    }
}

AdministrationGroupes.propTypes = {
    classes: PropTypes.object.isRequired,
    groupes: PropTypes.array.isRequired
};

export default withStyles(styles)(AdministrationGroupes);